<template>
  <Modal
    class="reset-modal"
    title="选择模板"
    v-model="show.value"
    width="auto"
    @on-ok="onConfirm"
  >
    <Input
      v-model="searchVal"
      search
      enter-button="搜索"
      placeholder="搜索活动名称"
      @on-search="onSearch"
    />
    <!-- 搜索结果 -->
    <section class="search-list">
      <div
        class="search"
        v-for="item in list"
        :key="item.id"
        @click="selectSearch(item)"
      >
        <img class="search-img" :src="item.coverPicUrl" />
        <p class="search-title">{{ item.title }}</p>
        <!-- 被选中 -->
        <div v-show="item.selected" class="iconfont icon-duigou selected"></div>
      </div>
      <!-- loading -->
    </section>
    <Spin v-show="showSpin" fix></Spin>
    <!-- 分页 -->
    <Page
      class="page-wrap"
      :total="total"
      :page-size="pageSize"
      show-total
      @on-change="onPageChange"
    />
  </Modal>
</template>

<script>
/* 业务组件 */
export default {
  name: "",
  components: {},
  props: {
    show: {
      type: Object,
      default: () => ({
        value: false
      })
    }
  },
  data() {
    return {
      searchVal: "", // 搜索值
      list: [],
      pageNum: 1,
      pageSize: 8,
      total: 0, // 活动总数量
      showSpin: false // 是否显示加载中
    };
  },
  watch: {},
  computed: {},
  methods: {
    // modal 确定
    onConfirm() {
      let [cur] = this.list.filter(item => item.selected);

      this.$emit("on-ok", cur);
    },
    onSearch() {
      this.pageNum = 1;
      this.initList();
    },
    selectSearch(item) {
      this.list.forEach(item => {
        if (item.selected) item.selected = false;
      });
      item.selected = true;
    },
    onPageChange(e) {
      this.pageNum = e;
      this.initList();
    },
    // 初始化列表
    initList() {
      let url = this.urlobj.getActivity;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.searchVal,
        isSend: 1
      };
      this.showLoading();
      this.$post(url, data)
        .then(res => {
          this.list = res.rows.map(item => ({
            id: item.id,
            coverPicUrl: item.coverPicUrl,
            title: item.title,
            selected: false
          }));
          this.total = res.total;
        })
        .finally(() => this.hideLoading());
    },
    showLoading() {
      this.showSpin = true;
    },
    hideLoading() {
      this.showSpin = false;
    }
  },
  created() {
    this.initList();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.reset-modal /deep/ .ivu-modal {
  width: fit-content;
}
.search-list {
  height: 400px;
  display: grid;
  grid-template-columns: repeat(4, 202px);
  grid-gap: 20px;

  margin: 20px 0;
}
.search {
  position: relative;
  width: 200px;
  height: 190px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  &:hover {
    box-shadow: 1px 1px 6px #ccc;
  }
}
.search-img {
  width: 100%;
  height: 90px;
  border-radius: 4px;
  background-color: #000;
  object-fit: fill;
}
.search-title {
  font-size: 15px;
  color: #333;
  margin-top: 20px;
  .textWrap();
  .ellipsisLn(2);
}
.icon-duigou {
  color: #fff;
  font-size: 50px;
}
.selected {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}
.page-wrap {
  text-align: center;
}
</style>
